<template>
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>


                    <v-flex row wrap xs12 sm12 md12>
                        <v-flex xs3 sm3 md3 text-center  class="labelFont">
                            <v-label >*網掛人員代號</v-label>
                        </v-flex>
                        <v-flex xs9 sm9 md9 pl-2>
                            <v-text-field :disabled="this.editIndex!=-1"  v-model="regUserId"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex row wrap xs12 sm12 md12>
                        <v-flex xs3 sm3 md3 text-center  class="labelFont">
                            <v-label >網掛人員名稱</v-label>
                        </v-flex>
                        <v-flex xs9 sm9 md9 pl-2>
                            <v-text-field  v-model="regUserName"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex row wrap xs12 sm12 md12>
                        <v-flex xs3 sm3 md3 text-center  class="labelFont">
                            <v-label >*檢查碼 </v-label>
                            <v-btn    color="info" dark  @click.native.stop="axios_getUUID">
                                自動產生
                            </v-btn>
                        </v-flex>
                        <v-flex xs9 sm9 md9 pl-2>
                            <v-text-field   v-model="regKey"   :loading="regKeyLoading" clearable></v-text-field>
                        </v-flex>
                    </v-flex>


                    <v-flex row warp xs12 sm12 md12 >
                        <v-flex xs5 sm5 md3 text-center  class="labelFont">
                            <v-label >*起始生效日期</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md9 pl-2 mt-3 >
                            <input style="border:1px solid black" id="inputDate1" type="date" >
                            <v-btn  title="清除日期" icon  @click.native.stop="clearDate('inputDate1')">
                                <v-icon  color="pink">mdi-delete</v-icon>
                            </v-btn>
                        </v-flex>

                    </v-flex>

                    <v-flex row warp xs12 sm12 md12 >
                        <v-flex xs5 sm5 md3 text-center  class="labelFont">
                            <v-label >*結束生效日期</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md9 pl-2 mt-3 >
                            <input style="border:1px solid black" id="inputDate2" type="date" >
                            <v-btn  title="清除日期" icon  @click.native.stop="clearDate('inputDate2')">
                                <v-icon  color="pink">mdi-delete</v-icon>
                            </v-btn>
                        </v-flex>

                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs3 sm3 md2 text-center  class="labelFont">
                            <v-label >備註</v-label>
                        </v-flex>
                        <v-flex xs9 sm9 md10 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="regMemo"  v-model="regMemo"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>

                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDialog">取消</v-btn>
            <v-btn  @click.native="save">送出</v-btn>
        </v-card-actions>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-card>
</template>

<script>
    export default {
        name: "EditRegUser",
        props:['editIndex','isShow','editObj'],
        data() {
            return {
                snTimeout:4000,
                snStatus:false,
                snText:'',
                regUserId:'',//網掛人員代號
                regUserName:'',//網掛人員名稱
                regKey:'',//檢查碼
                effStartDate:'',//起始生效日期(西元)
                effEndDate:'',//結束生效日期(西元)
                regMemo:'',//備註
                modifyObj:{},
                regKeyLoading:false,
            }
        },
        watch:{
            isShow(val){
                if(val==true&this.editIndex!=-1){

                    this.regUserId = this.editObj.regUserId==undefined?'':this.editObj.regUserId;
                    this.regUserName = this.editObj.regUserName==undefined?'':this.editObj.regUserName;
                    this.regKey = this.editObj.regKey==undefined?'':this.editObj.regKey;
                    this.regMemo = this.editObj.regMemo==undefined?'':this.editObj.regMemo;
                    this.effStartDate = this.editObj.effStartDate==undefined?'':this.$UtilityJs.AD2ROC_DateTime(this.editObj.effStartDate,'date');
                    this.effEndDate = this.editObj.effEndDate==undefined?'':this.$UtilityJs.AD2ROC_DateTime(this.editObj.effEndDate,'date');
                    document.getElementById("inputDate1").value = this.effStartDate;
                    document.getElementById("inputDate2").value = this.effEndDate;


                }else {
                    // let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                    this.regUserId = '';
                    this.regUserName = '';
                    this.regKey = '';
                    this.effStartDate = null;
                    this.effEndDate = null;
                    this.regMemo = '';
                    this.clearDate('inputDate1');
                    this.clearDate('inputDate2');
                }

            }
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 網掛人員' : '編輯 網掛人員'
            },
        },
        methods:{
            clearDate(id){
                document.getElementById(id).value = null;
            },
            closeDialog(){
                this.$emit('closeDialog');
            },
            save(){
                let effStartDate = document.getElementById("inputDate1").value;
                let effEndDate = document.getElementById("inputDate2").value;
                if(this.regUserId==''||this.regKey==''||effStartDate==""||effEndDate==""){
                    alert('請輸入網掛人員代號、檢查碼、起始,結束生效日期')
                }else {
                    let effStartDate = document.getElementById("inputDate1").value;
                    let effEndDate = document.getElementById("inputDate2").value;
                    this.modifyObj = {
                        regUserId : this.regUserId,
                        regUserName : this.regUserName ,
                        regKey: this.regKey,
                        regMemo: this.regMemo,
                        effStartDate: effStartDate==null||effStartDate==''?null:new Date(effStartDate+" 00:00:00").toJSON(),
                        effEndDate: effEndDate==null||effEndDate==''?null:new Date(effEndDate+" 00:00:00").toJSON(),

                    }

                    this.$emit('save',this.modifyObj);
                }

            },
            axios_getUUID (){ // 110/07/26 新增 自動產生UUID
                this.regKey = '';
                this.regKeyLoading = true;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "system/uuid";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.regKey = response.data.resultSet[0].value;
                        this.regKeyLoading = false;
                    }else{
                        this.regKey = '';
                        this.regKeyLoading = false;
                    }

                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.regKey = '';
                    } catch(err) {
                        console.log(err.toString())
                    }
                    this.regKeyLoading = false;
                });
            },
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }

    .custom-file-input {
        color: transparent;
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        height: 36px;
        /*min-height: 30px;*/
        /*max-height: 30px;*/
        vertical-align: middle;
    }
    .custom-file-input::-webkit-file-upload-button {
        visibility: hidden;
    }
    .custom-file-input::before {
        letter-spacing: 0.1em;
        content: '+人員影像';
        color: black;
        display: inline-block;
        background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
        border: 1px solid #999;
        border-radius: 15px;
        padding: 5px 8px;
        outline: none;
        white-space: nowrap;
        -webkit-user-select: none;
        cursor: pointer;
        text-shadow: 1px 1px #fff;
        font-weight: 700;
        /*font-size: 10pt;*/
    }
    .custom-file-input:hover::before {
        border-color: black;
    }
    .custom-file-input:active {
        outline: 0;
    }
    .custom-file-input:active::before {
        background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
    }


</style>